import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { DifficultSituation } from '../components/DifficultSituation';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { Trajectory } from '../components/Trajectory';
import { MaestroJohn } from '../components/MaestroJohn';
import { LoveGuidance } from '../components/LoveGuidance';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Policies } from '../components/Policies';
import { Footer } from '../components/Footer';
import { MobileActionBar } from '../components/MobileActionBar';
import { useTawkTo } from '../hooks/useTawkTo';
import { useViewportMeta } from '../hooks/useViewportMeta';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';
interface LandingProps {
  lockup: string;
  showTestimonials: boolean;
  showConsultationCount: boolean;
  freeInitialConsultation: boolean;
}
export function Landing({
  lockup,
  showTestimonials,
  showConsultationCount,
  freeInitialConsultation
}: LandingProps) {
  useViewportMeta();
  useGoogleTagManager();
  useTawkTo();
  return <div className="min-h-full w-full bg-carbon font-sans" data-id="element-210" data-mp="3pezw7zlj95rg">
      <Header lockup={lockup} data-id="element-211" data-mp="3kgophxqjbbdg" />
      <main data-id="element-212" data-mp="3khho2bfcauki">
        <MobileActionBar data-id="element-213" data-mp="3khpy7vk2vls0" />
        <Hero lockup={lockup} data-id="element-214" data-mp="l09x4bowdydq" />
        <Intro data-id="element-215" data-mp="kzgpz9m116v2" />
        <DifficultSituation data-id="element-216" data-mp="l008arfl9x9m" />
        <Services data-id="element-217" data-mp="l2cop05p7zkk" />
        <LoveGuidance data-id="element-218" data-mp="gz6exijdnq9c" />
        {showTestimonials ? <Testimonials data-id="element-219" data-mp="gzg8fg3msfjs" /> : null}
        <Trajectory showConsultationCount={showConsultationCount} data-id="element-220" data-mp="h1aly9ckp5du" />
        <MaestroJohn data-id="element-221" data-mp="c6n60yvmxjav" />
        <FinalCTA freeInitialConsultation={freeInitialConsultation} data-id="element-222" data-mp="c5v8hiih9bhy" />
        <Contact data-id="element-223" data-mp="78lncf24flzx" />
        <Policies data-id="element-224" data-mp="770seobwa11j" />
      </main>
      <Footer lockup={lockup} data-id="element-225" data-mp="14o8ywx1hhv70" />
    </div>;
}